/**
 * Platform locale exports
 * All 13 supported languages
 */

import en from './en.json';
import fr from './fr.json';
import es from './es.json';
import esMX from './es-MX.json';
import de from './de.json';
import ja from './ja.json';
import zhCN from './zh-CN.json';
import ptBR from './pt-BR.json';
import ru from './ru.json';
import ko from './ko.json';
import it from './it.json';
import nl from './nl.json';
import tr from './tr.json';
import ar from './ar.json';

export const locales = {
  en,
  fr,
  es,
  'es-MX': esMX,
  de,
  ja,
  'zh-CN': zhCN,
  'pt-BR': ptBR,
  ru,
  ko,
  it,
  nl,
  tr,
  ar,
};

export type SupportedLanguage = keyof typeof locales;

export const supportedLanguages: SupportedLanguage[] = [
  'en',
  'fr',
  'es',
  'es-MX',
  'de',
  'ja',
  'zh-CN',
  'pt-BR',
  'ru',
  'ko',
  'it',
  'nl',
  'tr',
  'ar',
];

export const rtlLanguages: SupportedLanguage[] = ['ar'];

export const isRTL = (lang: string): boolean => {
  return rtlLanguages.includes(lang as SupportedLanguage);
};

export const languageNames: Record<SupportedLanguage, string> = {
  en: 'English',
  fr: 'Francais',
  es: 'Espanol',
  'es-MX': 'Espanol (Mexico)',
  de: 'Deutsch',
  ja: '日本語',
  'zh-CN': '简体中文',
  'pt-BR': 'Portugues (Brasil)',
  ru: 'Русский',
  ko: '한국어',
  it: 'Italiano',
  nl: 'Nederlands',
  tr: 'Turkce',
  ar: 'العربية',
};

export default locales;
